import Styles from '@/contexts/Styles';

export default function useGetStyles(type: keyof typeof Styles): string {
  return Styles[type];
}
